<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col class="m-0 p-0">
          <form @submit.prevent="setQuestion">
            <b-overlay :show="sent" rounded="sm">
              <b-card bg-variant="light" class="m-0 p-0">
                <b-form-group class="mb-0">
                  <div v-if="questionupdated" class="alert alert-success p-3">
                    Question Updated
                  </div>
                  <h1 class="text-center">
                    Update Question {{ $route.params.trackid }}
                  </h1>
                  <b-form-group label="Select Category" label-for="category">
                    <b-form-select
                      id="category"
                      :options="categoryarr"
                      v-model="question.category"
                      @change="impjamb"
                      required
                    >
                      <b-form-select-option value="null"
                        >--Select category--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    v-if="question.category == 'Undergraduate'"
                    label="--Select Level--"
                    label-for="level"
                  >
                    <b-form-select
                      id="level"
                      :options="levelarr"
                      v-model="question.level"
                      required
                    />
                  </b-form-group>

                  <b-form-group
                    v-if="
                      question.category == 'Post UTME' ||
                        question.category == 'Undergraduate'
                    "
                    label="Institution/University"
                    label-for="selectinstitution"
                  >
                    <b-form-select
                      id="selectinstitution"
                      class="form-inp"
                      :options="institutionsarr"
                      v-model="question.institution"
                      @change="chgsel"
                      required
                    >
                      <b-form-select-option value="null"
                        >--Select Institution--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    v-if="question.category == 'Scholarship'"
                    label="Select Scholarship Exam Type"
                    label-for="selectsubject"
                  >
                    <b-form-select
                      id="scholarshiptype"
                      class="form-inp"
                      :options="scholarshiptypearr"
                      v-model="question.scholarshiptype"
                      label="Select Scholarship Type"
                      required
                    >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    v-if="
                      question.category == 'JAMB' ||
                        question.category == 'Post UTME'
                    "
                    label="Select Subject"
                    label-for="selectsubject"
                  >
                    <b-form-select
                      id="selectsbuject"
                      class="form-inp"
                      :options="subjectsarr"
                      v-model="question.subject"
                      label="Select Subject"
                      required
                    >
                      <b-form-select-option value="null"
                        >--Select Subject--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group label="Any Image Attachment to Question?">
                    <b-form-radio
                      v-model="question.attachment"
                      name="attach"
                      value="Yes"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="question.attachment"
                      name="attach"
                      value="No"
                    >
                      No
                    </b-form-radio>
                  </b-form-group>

                  <b-overlay :show="uploadingqimage">
                    <template #overlay>
                      <div class="text-center">
                        <b-icon-file-image
                          font-scale="3"
                          animation="throb"
                        ></b-icon-file-image>
                        <p>Uploading Image...</p>
                      </div>
                    </template>
                    <b-form-group>
                      <b-form-file
                        v-model="question.attachmentlink"
                        v-if="question.attachment == 'Yes'"
                        ref="file"
                        placeholder="Choose a file or drop it here"
                        drop-placeholder="Drop File here..."
                        @input="handleImage"
                      ></b-form-file>
                    </b-form-group>

                    <img
                      :src="attachmentfiles"
                      v-if="question.attachment == 'Yes'"
                      class="image-attachment"
                    />
                  </b-overlay>

                  <b-form-group
                    v-if="question.category != null"
                    label="Any Inline Image Attachement to Question?"
                  >
                    <b-form-radio
                      v-model="inlineattachment"
                      name="inlineattach"
                      value="Yes"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="inlineattachment"
                      name="inlineattach"
                      value="No"
                    >
                      No
                    </b-form-radio>
                  </b-form-group>

                  <b-modal centered id="inlinemodal" ok-only button-size="lg">
                    <p>Image Uploaded Successfully. Copy the Link below</p>
                    <code class="p-2 m-2 w-100 copyinline" id="copyinline"
                      ><p class="copytext">{{ inlineattachmentfile }}</p>
                      <b-icon-folder
                        @click="copylink()"
                        class="copyicon"
                        font-scale="2"
                      ></b-icon-folder
                    ></code>
                    <p>And paste in the Image link field.</p>
                    <b-form-input
                      @input="copynow()"
                      v-model="copytext"
                      class="copier"
                      id="copier"
                    ></b-form-input>
                  </b-modal>

                  <b-overlay :show="uploadinginlineimage">
                    <template #overlay>
                      <div class="text-center">
                        <b-icon-file-image
                          font-scale="3"
                          animation="throb"
                        ></b-icon-file-image>
                        <p>Uploading Image...</p>
                      </div>
                    </template>
                    <b-form-group
                      v-if="inlineattachment == 'Yes'"
                      label="Choose the file and Drop it here.  Then Copy the link after Uploading and Paste in the Link Field of the Image Property"
                    >
                      <b-form-file
                        v-model="question.attachmentlink"
                        v-if="inlineattachment == 'Yes'"
                        ref="inlinefile"
                        placeholder="Choose a file or drop it here."
                        drop-placeholder="Drop File here..."
                        @input="handleInlineImage"
                      ></b-form-file>
                    </b-form-group>
                    <img
                      :src="inlineattachmentfile"
                      v-if="inlineattachment == 'Yes'"
                      class="image-attachment"
                    />
                  </b-overlay>

                  <b-form-group
                    label="Passage to read(if any)"
                    label-for="passage"
                    v-if="question.subject == 'English'"
                  >
                    <vue2-tinymce-editor
                      v-model="question.passage"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="Input Question" label-for="question">
                    <vue2-tinymce-editor
                      v-model="question.question"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="Option A" label-for="optiona">
                    <vue2-tinymce-editor
                      v-model="question.optionA"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="Option B" label-for="optionb">
                    <vue2-tinymce-editor
                      v-model="question.optionB"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="Option C" label-for="optionc">
                    <vue2-tinymce-editor
                      v-model="question.optionC"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="Option D" label-for="optiond">
                    <vue2-tinymce-editor
                      v-model="question.optionD"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="Option E (Optional)" label-for="optione">
                    <vue2-tinymce-editor
                      v-model="question.optionE"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="Correct Option" label-for="correct">
                    <b-form-select
                      id="correct"
                      :options="options"
                      v-model="question.correct"
                      required
                    />
                  </b-form-group>

                  <b-form-group label="Is there a Solution?">
                    <b-form-radio
                      v-model="question.isSolution"
                      name="solatt"
                      value="Yes"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="question.isSolution"
                      name="solatt"
                      value="No"
                    >
                      No
                    </b-form-radio>
                  </b-form-group>
                  <b-form-group
                    v-if="question.isSolution == 'Yes' || question.isSolution"
                    label="Solution Type"
                  >
                    <b-form-select v-model="question.solutiontype">
                      <b-form-select-option value="null"
                        >--Solution Type--</b-form-select-option
                      >
                      <b-form-select-option value="Text"
                        >Text</b-form-select-option
                      >
                      <b-form-select-option value="Image"
                        >Image</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>
                  <b-form-group
                    v-if="
                      question.solutiontype == 'Text' &&
                        question.isSolution == 'Yes' || question.isSolution
                    "
                    label="Solution"
                    label-for="solution"
                  >
                    <vue2-tinymce-editor
                      v-model="question.solution"
                    ></vue2-tinymce-editor>
                  </b-form-group>
                  <b-overlay :show="uploadingqimage">
                    <template #overlay>
                      <div class="text-center">
                        <b-icon-file-image
                          font-scale="3"
                          animation="throb"
                        ></b-icon-file-image>
                        <p>Uploading Image...</p>
                      </div>
                    </template>
                    <b-form-group
                      v-if="
                        question.solutiontype == 'Image' &&
                          question.isSolution == 'Yes' || question.isSolution
                      "
                      label="Solution Image"
                    >
                      <b-form-file
                        v-model="solutionlink"
                        ref="sfile"
                        placeholder="Choose a file or drop it here"
                        drop-placeholder="Drop File here..."
                        @input="handlesImage"
                      ></b-form-file>
                    </b-form-group>
                    <img
                      :src="solutionlink"
                      v-if="
                        question.solutiontype == 'Image' &&
                          question.isSolution == 'Yes' || question.isSolution
                      "
                      class="image-attachment mb-3"
                    />
                  </b-overlay>

                  <b-form-group label="Topic Reference">
                    <b-form-input
                      v-model="question.topicref"
                      placeholder="Topic Reference"
                    ></b-form-input>
                  </b-form-group>
                  <b-row>
                    <b-col></b-col>
                    <b-col md="6">
                      <div
                        v-if="questionupdated"
                        class="alert alert-success p-3"
                      >
                        Question Updated
                      </div>
                      <b-form-group>
                        <b-overlay
                          :show="uploading"
                          rounded
                          opacity="0.6"
                          spinner-small
                          spinner-variant="primary"
                          class=""
                        >
                          <b-button
                            :disabled="emptyin"
                            type="submit"
                            class="btn-sub p-1 w-100"
                            variant="warning"
                          >
                            Update Question
                          </b-button>
                        </b-overlay>
                      </b-form-group>
                    </b-col>
                    <b-col> </b-col>
                  </b-row>
                </b-form-group>
                <div hidden class="text-center">
                  {{ nexttrid }} {{ prevtrid }}
                  <b-button-group size="lg">
                    <b-button
                      :to="{
                        name: 'editquestionsuper',
                        params: { trackid: prevtrid }
                      }"
                      variant="primary"
                      >Prev Question</b-button
                    >
                    <b-button
                      :to="{
                        name: 'editquestionsuper',
                        params: { trackid: nexttrid }
                      }"
                      variant="primary"
                      >Next Question</b-button
                    >
                  </b-button-group>
                </div>
              </b-card>
            </b-overlay>
          </form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store";
import axios from "axios";
import { Vue2TinymceEditor } from "vue2-tinymce-editor";

export default {
  components: {
    Vue2TinymceEditor
  },
  data() {
    return {
      inlineattachmentfile: "",
      inlineattachment: "No",
      copytext: "",
      showcopy: false,
      editorUrl: "https://quicktest.futavilla.com/js/ckeditor/ckeditor.js",
      //editorUrl: "http://localhost/quicktest/ckeditor/ckeditor.js",
      config: {
        mathjaxClass: "myclass",
        mathJaxLib:
          "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML",
        extraPlugins: ["ckeditor_wiris", "mathjax"],
        allowedContent: true,
        removePlugins: [],

        toolbarGroups: [
          { name: "document", groups: ["mode", "document", "doctools"] },
          { name: "clipboard", groups: ["clipboard", "undo"] },
          {
            name: "editing",
            groups: ["find", "selection", "spellchecker", "editing"]
          },
          { name: "forms", groups: ["forms"] },
          "/",
          { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
          {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi", "paragraph"]
          },
          { name: "links", groups: ["links"] },
          { name: "insert", groups: ["insert"] },
          "/",
          { name: "styles", groups: ["styles"] },
          { name: "colors", groups: ["colors"] },
          { name: "tools", groups: ["tools"] },
          { name: "others", groups: ["others"] },
          { name: "about", groups: ["about"] }
        ]
      },
      emptyin: this.empties,
      leaving: false,
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [
          {
            script: "super"
          },
          {
            script: "sub"
          }
        ],
        ["code-block"],
        ["formula"]
      ],
      dismissCountDown: 60,
      subjectsarr: [],
      categoryarr: [],
      options: [
        {
          value: null,
          text: "--Choose Correct Option--"
        },
        {
          value: "A",
          text: "A"
        },
        {
          value: "B",
          text: "B"
        },
        {
          value: "C",
          text: "C"
        },
        {
          value: "D",
          text: "D"
        },
        {
          value: "E",
          text: "E"
        }
      ],
      levelarr: [],
      scholarshiptypearr: [],
      institutionsarr: [],
      question: this.getForm(),
      sent: false,
      uploading: false,
      questionupdated: false,
      filelink: "",
      uploadingqimage: false,
      uploadinginlineimage: false,
      attachmentfiles: "",
      solutionlink: "",
      nexttrid: "",
      prevtrid: ""
    };
  },

  created() {
    if (!this.loggedin) {
      this.$router.push({
        name: "login"
      });
    }
    if (this.details.clearance == "Normal") {
      this.$router.push({
        name: "welcome"
      });
    }
    let inst = this.allinsti.map(x => x.name);
    let typesarr = this.Categories.map(x => x.name);
    this.categoryarr = typesarr;

    this.institutionsarr = inst;
  },

  beforeRouteEnter(to, from, next) {
    store.dispatch("exam/retrieveInstitutions");
    //store.dispatch("admin/fetchQuestion");
    store.dispatch("admin/fetchQuestion2").then(() => {
      next();
    });
  },
  mounted() {
    //this.setDetails()
    let catint = "";
    if (this.editquestion.category == "JAMB") {
      catint = "JAMB";
      if (this.editquestion.category == "JAMB") {
        let subbb = this.allinsti
          .filter(x => x.name == "JAMB")
          .map(x => x.subjects_offered);
        this.subjectsarr = JSON.parse(subbb);
      }
    } else {
      catint = this.editquestion.institution;
      let subbb = this.allinsti
        .filter(x => x.name == this.editquestion.institution)
        .map(x => x.subjects_offered);
      this.subjectsarr = JSON.parse(subbb);
    }

    this.attachmentfiles = this.editquestion.image_link;
    this.solutionlink = this.editquestion.solution;

    this.question = {
      institution: catint,
      subject: this.editquestion.subject,
      category: this.editquestion.category,
      level: this.editquestion.level,
      scholarshiptype: this.editquestion.scholarship,
      isAttachment: this.editquestion.isAttachment,
      attachmentfile: this.editquestion.image_link,
      question: this.editquestion.question,
      optionA: this.editquestion.a,
      optionB: this.editquestion.b,
      optionC: this.editquestion.c,
      optionD: this.editquestion.d,
      optionE: this.editquestion.e,
      correct: this.editquestion.correct,
      isSolution: this.editquestion.isSolution,
      solutiontype: this.editquestion.solutiontype,
      solution: this.editquestion.solution,
      trackid: this.editquestion.track_id,
      passage: this.editquestion.passage,
      topicref: this.editquestion.topic_reference
    };
  },

  methods: {
    handleImage() {
      this.uploadingqimage = true;
      let ifile = this.$refs.file.files[0];
      let formData = new FormData();

      formData.append("image", ifile);

      axios
        .post(
          "https://quicktest.futavilla.com/apis/Qfilehandler.php",
          //"http://localhost/quicktest/src/apis/Qfilehandler.php",
          formData,
          {
            header: {
              "Content-Type": "multipart/form-data",
              timeout: 5
            }
          }
        )
        .then(response => {
          this.uploadingqimage = false;
          this.$bvModal
            .msgBoxOk(
              "Image Uploaded Successfully. Proceed with Question Upload.",
              {
                title: "Image Uploaded",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          //console.log(response.data);
          this.filelink = response.data.url;

          this.setUFile(response.data.url);

          this.attachmentfiles = response.data.url;
        })
        .catch(() => {
          this.$bvModal
            .msgBoxOk(
              "Check your Network Connection. Could not upload Image.",
              {
                title: "No Network Connection",
                size: "xs",
                centered: true
              }
            )
            .then(() => {
              this.uploadingqimage = false;
            });
          //console.log(error);
        });
    },
    handlesImage() {
      this.uploadingqimage = true;
      let ifile = this.$refs.sfile.files[0];
      let formData = new FormData();

      formData.append("image", ifile);

      axios
        .post(
          "https://quicktest.futavilla.com/apis/Qfilehandler.php",
          //"http://localhost/quicktest/src/apis/Qfilehandler.php",
          formData,
          {
            header: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(response => {
          this.uploadingqimage = false;
          this.$bvModal
            .msgBoxOk(
              "Image Uploaded Successfully. Proceed with Question Upload.",
              {
                title: "Image Uploaded",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          this.solutionlink = response.data.url;
          //console.log(response.data);
        })
        .catch(() => {
          this.$bvModal
            .msgBoxOk(
              "Check your Network Connection. Could not upload Image.",
              {
                title: "No Network Connection",
                size: "xs",
                centered: true
              }
            )
            .then(() => {
              this.uploadingqimage = false;
            });
          //console.log(error);
        });
    },

    handleInlineImage() {
      this.uploadinginlineimage = true;
      let ifile = this.$refs.inlinefile.files[0];
      let formData = new FormData();

      formData.append("image", ifile);

      axios
        .post(
          "https://quicktest.futavilla.com/apis/Qfilehandler.php",
          //"http://localhost/quicktest/src/apis/Qfilehandler.php",
          formData,
          {
            header: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(response => {
          this.uploadinginlineimage = false;
          this.$bvModal.show("inlinemodal");
          this.filelink = response.data.url;
          //console.log(response.data);

          //this.setFile(response.data.url);

          this.inlineattachmentfile = response.data.url;
          this.copytext = response.data.url;
        })
        .catch(() => {
          this.$bvModal
            .msgBoxOk(
              "Check your Network Connection. Could not upload Image.",
              {
                title: "No Network Connection",
                size: "xs",
                centered: true
              }
            )
            .then(() => {
              this.uploadinginlineimage = false;
            });
          //console.log(error);
        });
    },

    leaveRoute() {
      this.leaving = true;
      this.$bvToast.toast("Press the Back Button again to Exit", {
        noCloseButton: true,
        solid: true,
        variant: "dark",
        toaster: "b-toaster-bottom-center"
      });
    },
    stayRoute() {
      this.$bvToast.toast("Exiting Canceled", {
        noCloseButton: true,
        solid: true,
        variant: "dark",
        toaster: "b-toaster-bottom-center"
      });
    },
    chgsel() {
      let subbb = this.allinsti
        .filter(x => x.name == this.question.institution)
        .map(x => x.subjects_offered);
      this.subjectsarr = JSON.parse(subbb);
    },
    impjamb() {
      let inst = this.allinsti
        .filter(
          x => x.available == "Yes" && x.category == this.question.category
        )
        .map(x => x.name);
      this.institutionsarr = inst;

      if (this.question.category == "JAMB") {
        let subbb = this.allinsti
          .filter(x => x.name == "JAMB")
          .map(x => x.subjects_offered);
        this.subjectsarr = JSON.parse(subbb);
      }
    },

    setQuestion() {
      this.setloader();
      this.sent = true;
      //console.log(this.question);
      this.question.attachmentfile = this.filelink;
      if (this.question.solutiontype == "Image") {
        this.question.solution = this.solutionlink;
      }

      this.updateQuestion(this.question).then(() => {
        this.questionupdated = true;
        this.uploading = false;
        this.sent = false;
      });
    },
    getForm() {
      return {
        institution: null,
        subject: null,
        category: null,
        level: null,
        scholarshiptype: null,
        passage: "",
        isAttachment: "",
        attachmentlink: "",
        attachmentfile: "",
        question: "",
        optionA: "",
        optionB: "",
        optionC: "",
        optionD: "",
        optionE: "",
        correct: null,
        isSolution: "No",
        solutiontype: null,
        solution: "",
        topicref: "",
        admin: this.$store.state.loginmaster.details.fullname,
        trackid: this.$store.state.loginmaster.details.trackid
      };
    },
    setloader() {
      this.uploading = true;
    },

    copylink() {
      var cop = document.getElementById("copier");
      cop.select();
      cop.setSelectionRange(0, 99999);
      document.execCommand("copy");
    },

    copynow() {
      document.execCommand("copy");
    },

    setDetails() {
      let curindex = this.questionsarr.findIndex(
        o => o.track_id == this.$route.params.trackid
      );
      let nextindex = "";
      let previndex = "";

      if (curindex >= this.questionsarr.length) {
        nextindex = this.questionarr.length;
      } else {
        nextindex = curindex + 1;
      }

      if (curindex <= 0) {
        previndex = 0;
      } else {
        previndex = curindex - 1;
      }

      this.nexttrid = this.questionsarr[nextindex].track_id;
      this.prevtrid = this.questionsarr[previndex].track_id;
    },

    ...mapActions("admin", ["updateQuestion"]),
    ...mapActions("admin", ["chekquestion", "setUFile"])
  },
  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      loggedin: state => state.loginmaster.loggedIn,
      editquestion: state => state.admin.editquestion[0],
      allinsti: state => state.exam.allinstitutions,
      questionsarr: state => state.admin.questionsfor,
      fileimage: state => state.admin.quimageurl,
      Categories: state => state.admin.Categories
    }),
    leav() {
      return this.leaving;
    },
    empties() {
      if (
        this.question.question == "" ||
        this.question.optionA == "" ||
        this.question.optionB == "" ||
        this.question.optionC == "" ||
        this.question.optionD == ""
      ) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.copyinline {
  background-color: #000000;
  color: white;
  display: inline-flex;
}
.copyicon {
  cursor: pointer;
}

.copier {
  position: absolute;
  left: -9999px;
}

@media screen and (max-width: 768px) {
  .image-attachment {
    width: 100%;
    height: 200px;
  }
}

@media screen and (min-width: 768px) {
  .image-attachment {
    width: 100%;
    height: 300px;
  }
}
</style>
